import { render, staticRenderFns } from "./AddOpportunite.vue?vue&type=template&id=080dba0a&"
import script from "./AddOpportunite.vue?vue&type=script&lang=ts&"
export * from "./AddOpportunite.vue?vue&type=script&lang=ts&"
import style0 from "./AddOpportunite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports